// @ts-ignore
import emitter from "tiny-emitter/instance";

export default {
  $on: (id: string, callback: any) => emitter.on(id, callback),
  $off: (id: string, callback: any) => emitter.off(id, callback),
  $emit: (id: string, ...data: any[]) => emitter.emit(id, ...data),
};
